import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { FormGroup, FormControl, FormArray, FormBuilder, Validators, AbstractControl, EmailValidator } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AppointmentService } from 'src/app/Services/Appointment/appointment.service'
import { DatePipe } from '@angular/common'
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { colors } from 'src/utils/colors';
import {  ChangeDetectionStrategy } from '@angular/core';
import { CalendarEvent, CalendarView } from 'angular-calendar';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { User} from 'src/app/Model/User/user.model';
import { UserRole } from 'src/app/Model/Role/user-role.model'
import { AuthenticationService } from 'src/app/Services/Authentication/authentication.service';
import { AsYouType } from 'libphonenumber-js'
import { DlDateTimeDateModule, DlDateTimePickerModule } from 'angular-bootstrap-datetimepicker';
//import { Script } from 'vm';



import {
  isSameMonth,
  isSameDay,
  startOfMonth,
  endOfMonth,
  startOfWeek,
  endOfWeek,
  startOfDay,
  endOfDay,
  format,
} from 'date-fns';

interface Appointment {
  fullName: string;
  timeIn: string;
  pid:string;
  phoneNumber:string;
  branch:string;
  salesRep:string;
   
 }


@Component({
  selector: 'app-create-appointment',
  templateUrl: './create-appointment.component.html',
  styleUrls: ['./create-appointment.component.css']
})
export class CreateAppointmentComponent implements OnInit {

heardAbout;
    
 //_url= 'http://multiinspectionreport.com/reception/api';
 //_url= 'https://test.appointele.com/api';
 //_url= 'https://demo.appointele.com/api';
_url= 'https://ciot.appointele.com/api';
//_url= 'https://ciot.appointele.ca/api';
 
 color;
  events: any;
  items: Array<CalendarEvent<{ time: any }>> = [];
  viewDate: Date = new Date();
  view: CalendarView = CalendarView.Month;
  events$: Observable<CalendarEvent<{ appointment: Appointment }>[]>;
  activeDayIsOpen: boolean = false;

  branchfromlogin;
  alltodaysappointment=[];
checkinview=false;
  checkInDate;
branch;
clientName;
clientPhoneNumber;
clientDetails;

  branchselected=false;
  salesRep=[];
loading=false;
questionaireForm:FormGroup;
date;
error:any = '';
success = '';
branchs;
loggedInUserBranch;
loggedInUserFullname;
loggedInUserId;
currentUser:User;
role;
username;
salesRepID;

validationMessages = {
  'fullName': {
    'required': 'Full Name is required'
  },
  'phoneNumber': {
    'required': 'Phone Number is required'
  },

  'email': {
    'required': 'Email is required',
    'pattern' : 'Please enter a valid email'
  },

 'LookingFor': {
  'required': 'required'
},
'describesYouk': {
  'required': 'required'
},
'ageGroup': {
  'required': 'required'
},
'branch': {
  'required': 'Branch is required'
},

'salesRep': {
  'required': 'Sales Representative is required'
},
//'whatLoveProduct': {
 // 'required': 'required'
//},
'status': {
  'required': 'required'
}

};


formErrors = {
  'fullName': '',
  'phoneNumber': '',
  'email': '',
  'lookingFor': '',
  'describesYou': '',
  'salesRep': '',
  'ageGroup': '',
  'branch': '',
  'status': '',
}



  constructor(private fb: FormBuilder,
    private router: Router,
    private _location: Location,
    private _http: HttpClient,
    private actroute: ActivatedRoute,
    private _authenticationService: AuthenticationService,
    private _appointment: AppointmentService,
    public datepipe: DatePipe) {

      this._authenticationService.currentUser.subscribe(x => this.currentUser = x);
      if(this.currentUser){
        this.username=this.currentUser.firstName+' '+this.currentUser.middleName+' '+this.currentUser.lastName;
        this.branch=this.currentUser.branch;
        this.branchfromlogin=this.currentUser.branch
        this.role=this.currentUser.role;


  
        this.loggedInUserFullname= this.username;
        this.loggedInUserBranch= this.branch
        this.loggedInUserId=this.currentUser.userName;
    
        
    
       }
     }


ngOnInit(): void {

//  this.asYouType = new AsYouType('US').input('#phoneNumber');
  //this.format = format('2133734253', 'US', 'International');
  //this.parse = parse('(0777) 844 822', 'RO');

  //this.fetchEvents();

  this.getAllBranchs();

  this.questionaireForm = this.fb.group({
    pid: new FormControl(''),
    clientID: new FormControl(''),
     fullName: new FormControl('', [Validators.required]),
     phoneNumber: new FormControl('',[Validators.required]),
     email: new FormControl(''),
     branch: new FormControl('',[Validators.required]),
     requestType: new FormControl(''),
     status: new FormControl(''),
     timeIn: new FormControl(''),
     timeOut: new FormControl(''),
    ageGroup: new FormControl(''),
    salesRep: new FormControl('',[Validators.required]),
    clientele: new FormControl(''),
    personCount: new FormControl('Unknown'),
     companyName: new FormControl(''),
     describesYou: new FormControl(''),
     lookingFor: new FormControl(''),
     heardAboutUs: new FormControl(''),
     workWithFabricator: new FormControl(''),
     covid: new FormControl('No'),
     webLink: new FormControl(''),
     tag: new FormControl(''),
     notes: new FormControl(''),
     createdBy: new FormControl(this.loggedInUserId),

     
   });


   this.actroute.paramMap.subscribe(params => {
    // This is never executed, for route is not recognized
    // let myArray=params.getAll('extra');
    const salesRepName = params.get('extra')
    var datetime = params.get('extra1')
    this.branch = params.get('extra2');
    //extra 3-5 is from client Profile  
    const clientID= params.get('extra3');
    this.clientName= params.get('extra4');
    this.clientPhoneNumber= params.get('extra5');
    
    console.log(this.branchfromlogin);
    if (this.branch!=null && (datetime!="" && datetime!=null)) {
      this.branchselected=true;
     // this.getSalesRep(this.branch);
      
    
     this.patchfromfreetime(salesRepName, datetime,this.branch);
     
    } else if(clientID!=null && clientID!=''){
      console.log(this.clientName);
      this.branchselected=true;
      this.patchfromClientDetails(this.branch,clientID, this.clientName, this.clientPhoneNumber);
    }
    else {
   
    //patching user's branch as a default branch for form
   this.questionaireForm.patchValue({
    // departmentId: assetformmodel[0].department,
     branch: this.branchfromlogin,
   });
   this.branchselected=true;
   this.getSalesRep(this.branchfromlogin);
    }
  });





   /**this.questionaireForm.get('phoneNumber').valueChanges.subscribe(val => {
    var number = val;
    console.log(number)
    
    this.asYouType = new AsYouType('US').input(number)
      // this.branchselected = true;
   //  /   this. getSalesRep(this.userappointment[0].branch);
       this.questionaireForm.patchValue({
         phoneNumber:this.asYouType
       })
      })**/


   //error handling
   this.questionaireForm.valueChanges.subscribe((data) => {
     this.logValidationErrors(this.questionaireForm);
   })
}//End og NgOnInit


  patchfromClientDetails(branch: any, clientID: string, clientName: string, clientPhoneNumber: string) {
    console.log(clientName)


    this._appointment.getSalesRepByBranch(branch).subscribe(
      (res) => {
        this.salesRep = res;
       // console.log(salesRepName);
        this.branchselected = true;
     
  
        this._appointment.getClientDetails(clientID, clientName, clientPhoneNumber).subscribe(
          response =>  {
            this.clientDetails= response[0];
            //console.log(this.clientDetails['fullName']);
            this.questionaireForm.patchValue({
              // departmentId: assetformmodel[0].department,
              clientID: clientID,
               branch: this.branch,
               fullName: this.clientName,
               phoneNumber:this.clientPhoneNumber,
               email: this.clientDetails.email,
               describesYou:this.clientDetails.describesYou,
               companyName:this.clientDetails.companyName,
               
             });
          },
          (err) => {
            this.error = err;
          }
        );
        
      }
      ,
      (err) => {
        this.error = err;
      }
    );


   
  
 

      
       
    
  }




patchfromfreetime(salesRepName, datetime, branch){

  this._appointment.getSalesRepByBranch(branch).subscribe(
    (res) => {
      this.salesRep = res;
     // console.log(salesRepName);
      this.branchselected = true;
      for(let o of this.salesRep){
       // console.log(o.fullName);
       if(o.fullName==salesRepName){

         this.salesRepID=o.userID;
       } 
     };
     var dtime=new Date(datetime);
     var tout=new Date(dtime.setMinutes(dtime.getMinutes() + 60));

      this.questionaireForm.patchValue({
        // departmentId: assetformmodel[0].department,
         branch: this.branch,
         timeIn: datetime,
         timeOut:tout,
         salesRep:this.salesRepID,
       });
       console.log(this.salesRepID);
    }
    ,
    (err) => {
      this.error = err;
    }
  );
}


onSubmit(){
  this.logValidationErrors(this.questionaireForm );
 
this.loading=true;
  //this.questionaireForm.patchValue({
    //covid: covid});
  //const categoryselect=this.questionaireForm.get('category').value;
 // if(categoryselect==="Machinery" || categoryselect==="Laptops" || categoryselect==="Desktops" || categoryselect==="Printer");

 //console.log(this.questionaireForm.value);
       this._appointment.insertNewAppointmentByReception(this.questionaireForm.value)
    .subscribe(//subscribe to Observable
      response => {console.log('Success!', response);
      this.success=response['SUCCESS'];
      this.questionaireForm.reset;        
      document.getElementById("openSuccessModalButton").click();
      this.loading=false;
    },
      error => {console.error('Error!', error);
        this.loading=false;
      this.error=error.error.text ;
    }       
    );

        }



getAllBranchs(){
  this._appointment.getAllBranchs().subscribe(
    (res) => {

      this.branchs = res;
    },
    (err) => {
      this.error = err;
    }
  );
}




getSalesRep(branch){
 // console.log(branch);
  if (branch != "None" || branch!="") {
    this._appointment.getSalesRepByBranch(branch).subscribe(
      (res) => {
        this.salesRep = res;
       console.log(this.salesRep);
        this.branchselected = true;
 
      }
      ,
      (err) => {
        this.error = err;
      }
    );
  }
  else {
    this.branchselected = true;
  }



}



patchCheckIn(){
  this.checkinview=true;
 /**  let dateTime = new Date();
  this.date=new Date();
let latest_date =this.datepipe.transform(this.date, 'yyyy-MM-dd h:mm a');

  this.questionaireForm.patchValue({
    timeIn:latest_date
  });**/
}



patchCheckOut(){
  let dateTime = new Date();
  this.date=new Date();
let latest_date =this.datepipe.transform(this.date, 'yyyy-MM-dd h:mm a');

  this.questionaireForm.patchValue({
    timeOut:latest_date
  });
}


backClicked() {
  this._location.back();
}




logValidationErrors(group: FormGroup ): void {
  //get the keys from FormGroup object and checks all the keys
  Object.keys(group.controls).forEach((key: string) => {
    const abstractControl = group.get(key);
    //if the key is part of nested FormGroup or any FormGroup then rerun it through the method again to extract formControl
    if (abstractControl instanceof FormGroup) {
      this.logValidationErrors(abstractControl);
    } else {
      //clear any previous error
      this.formErrors[key] = '';
      //check Validation of the formControl
      if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {
        //if not valid then get the error message of whatever the validation error is from the validationMessage method
        const messages = this.validationMessages[key];
        //for every error in validation get the error key and assign it to the formControl name is formError method
        for (const errorkey in abstractControl.errors) {
          if (errorkey) {
      //      console.log(key);

            this.formErrors[key] += messages[errorkey] + ''
          }
        }
      }
    }

  });
}




onMyDateChange(event){
  console.log(event);
}






 /************************************************************************************************************************** */
  //Calendar
  /**************************************************************************************************************************** */
  fetchEvents(): void {

    const getStart: any = {
      month: startOfMonth,
      week: startOfWeek,
      day: startOfDay,
    }[this.view];

    const getEnd: any = {
      month: endOfMonth,
      week: endOfWeek,
      day: endOfDay,
    }[this.view];

  this.events$ = this._http.get(`${this._url}/active_all_appointment_for_branch_get.php?branch=${this.branch}`)
  .pipe(
    map(({ results }: { results: Appointment[] }) => {
      console.log(results);
      return results.map((appointment: Appointment) => {
        this.colorForRep(appointment.salesRep);
     /**   if(appointment.salesRep=='Nicolas Salazar'){
          this.color=colors.blue;
        }else if(appointment.salesRep=='Tom Kizito'){
          this.color=colors.yellow;
        }**/
        return {
         
          title: appointment.fullName+' - '+(new Date(appointment.timeIn).toLocaleTimeString()).replace(/:\d+ /, ' ')+' - '+appointment.salesRep,
          start: new Date(
            appointment.timeIn
          ),
          
          color:this.color,
         // cssClass: main-dashboard.component.css,
          meta: {
            appointment,
          },

        };
      });
    })
  );


}


dayClicked({
  date,
  events,
}: {
  date: Date;
  events: CalendarEvent<{ appointment: Appointment }>[];
}): void {
  if (isSameMonth(date, this.viewDate)) {
    if (
      (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
      events.length === 0
    ) {
      this.activeDayIsOpen = false;
    } else {
      this.activeDayIsOpen = true;
      this.viewDate = date;
    }
  }

}



eventClicked(event: CalendarEvent<{ appointment: Appointment }>): void {
  /**window.open(
    `https://multiinspectionreport.com/reception/appointment-details;extra=${event.meta.appointment.appointmentID};extra1=${event.meta.appointment.fullName};extra2=${event.meta.appointment.phoneNumber}`,
    '_blank'
  );**/

  console.log(event.meta.appointment);
  if(event.meta.appointment.fullName=='Lunch'){
    this.router.navigate(['../lunch-assignment',{extra:event.meta.appointment.pid,extra1:event.meta.appointment.timeIn,extra2:event.meta.appointment.salesRep,extra3:event.meta.appointment.branch}],{relativeTo:this.actroute});
  }else{
 
  this.router.navigate(['../appointment-details', { extra:event.meta.appointment.pid, extra1: event.meta.appointment.fullName,extra2:event.meta.appointment.phoneNumber,extra3:event.meta.appointment.branch }], { relativeTo: this.actroute });
}
}






unassignSalesRep(){
  this.questionaireForm.patchValue({
salesRep:"",
  });

}

colorForRep(salesRep){
  if(salesRep=='Nicolas Salazar'){
    this.color=colors.darkgray;
  }else if(salesRep=='Sonia Garofolo'){
    this.color=colors.yellow;
  } else if(salesRep=='Nancy Ventura'){
    this.color=colors.purple;
  }else if(salesRep=='Olivia Dobrovich'){
    this.color=colors.pink;
  } else if(salesRep=='Jason Branco'){
    this.color=colors.green;
  }else if(salesRep=='Ryan Li'){
    this.color=colors.darkgreen;
  } else if(salesRep=='Caelyn Huang'){
    this.color=colors.purpleblue;
  }else if(salesRep=='Alyssa Vani'){
    this.color=colors.info;
  } else if(salesRep=='Alex Karlee Lafarciola'){
    this.color=colors.brightblue;
  }else if(salesRep=='Magdalena Wojtachnio'){
    this.color=colors.orange;
  } else if(salesRep=='Christelle Aniceto'){
    this.color=colors.lightgray;
  }else if(salesRep=='Zach Cannarozzo'){
    this.color=colors.blue;
  } else if(salesRep=='Alexia Rupolo'){
    this.color=colors.brown;
  }else if(salesRep=='Sandra Arango'){
    this.color=colors.red;
  } else if(salesRep=='Lauren Richardson'){
    this.color=colors.coralred;
  }else {
    this.color=colors.black;
  }

}





}

